export const SET_USER = 'SET_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const SET_LOGIN_ERR = 'SET_LOGIN_ERR';
export const GET_USER = 'GET_USER';
